var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.option)?_c('v-select',{attrs:{"value":_vm.option,"single-line":"","hide-details":"","solo":"","background-color":_vm.option.color,"flat":"","dense":"","return-object":"","items":_vm.computedOptions,"disabled":false},on:{"change":function($event){return _vm.$emit('change', $event)}}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }